import { useState, useEffect } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Menu } from "lucide-react";
import Logo from "@/components/Logo";

const LINKS = [
  { id: "bio", label: "BIO" },
  { id: "gigs", label: "GIGS" },
  { id: "mixes", label: "MIXES" },
  { id: "gallery", label: "GALLERY" },
  { id: "booking", label: "BOOK" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#050505]/80 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 sm:px-8 flex items-center justify-between h-16">
        <button
          data-testid="logo-button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="group flex items-center gap-2 font-heading font-black tracking-tighter text-base sm:text-lg uppercase hover:text-[#FF2A2A] transition-colors"
        >
          <span className="text-[#F5F5F5] group-hover:text-[#FF2A2A] transition-colors">
            <Logo size={22} />
          </span>
          DISKO<span className="text-[#FF2A2A]">.</span>BHUTE
        </button>

        <ul className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <li key={l.id}>
              <button
                data-testid={`nav-link-${l.id}`}
                onClick={() => scrollTo(l.id)}
                className="font-mono text-xs tracking-[0.25em] uppercase text-[#F5F5F5] hover:text-[#FF2A2A] transition-colors"
              >
                {l.label}
              </button>
            </li>
          ))}
        </ul>

        <div className="md:hidden">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button
                data-testid="mobile-menu-trigger"
                aria-label="Open menu"
                className="p-2 border border-white/15 hover:border-[#FF2A2A] transition-colors"
              >
                <Menu size={18} />
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
              align="end"
              className="rounded-none bg-[#0A0A0A] border border-white/10 min-w-[180px] font-mono"
            >
              {LINKS.map((l) => (
                <DropdownMenuItem
                  key={l.id}
                  data-testid={`mobile-nav-${l.id}`}
                  onClick={() => scrollTo(l.id)}
                  className="rounded-none text-xs tracking-[0.25em] uppercase focus:bg-[#FF2A2A] focus:text-black cursor-pointer"
                >
                  {l.label}
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </nav>
    </header>
  );
}
